import { COMBO_BASE_TIME } from '../../../State/reducers/score';
import { ComboStarAnim } from '../../Animations/ComboStarAnim';
import { CircularBar } from './CircularBar';

export class ComboMeter extends CircularBar {
    private readonly comboStarAnim: ComboStarAnim;

    constructor() {
        super('x1');
        this.comboStarAnim = new ComboStarAnim(1.1);
        this.addChild(this.comboStarAnim);
    }

    public updateComboNum(multiplier: number, oldmultiplier: number) {
        this.pausedTime = 0;
        this.label.text = 'x' + multiplier.toString(10);
        this.depleteTime = multiplier === 1 ? 0 : COMBO_BASE_TIME - 500 * (multiplier - 1);
        if (multiplier !== oldmultiplier && multiplier !== 1) {
            this.comboStarAnim.play();
        }
        this.startTime = Date.now();
        if (this.paused) {
            this.pauseTime = Date.now();
            this.drawMask(100);
        }
    }

    public cleanUp() {
        super.cleanUp();
        this.comboStarAnim.destroy();
    }
}
